import { cn } from "@/common/helpers/utils";
import i18next from "i18next";
import type { ReactElement } from "react";
import { LocationDisplay } from "./relocation-order-location-display";
import type { RelocationOrderRoutePoint } from "./relocation-order-route-points";

export interface RelocationOrderRoutePointRenderOptions {
  rowClassName: string;
  labelClassName: string;
  valueClassName: string;
  currentMarkerClassName: string;
}

export function renderRelocationOrderRoutePoint(
  point: RelocationOrderRoutePoint,
  options: RelocationOrderRoutePointRenderOptions,
): ReactElement {
  return (
    <div key={point.key} className={options.rowClassName}>
      <span className={options.labelClassName}>{i18next.t(point.labelKey)}</span>
      <span className={options.labelClassName}>:</span>
      <LocationDisplay
        branch={point.branch}
        address={point.address}
        className={cn("min-w-0", options.valueClassName)}
      />
      {point.isCurrent ? <span className={options.currentMarkerClassName}>({i18next.t("fit:Current")})</span> : null}
    </div>
  );
}
